import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 py-10 px-4 text-center border-t border-gray-800" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <p className="font-sans text-gray-400 mb-4" data-id="element-128">
          © 2026 The Pawfect Shot MegaPack. All rights reserved.
        </p>
        <div className="font-sans text-sm text-gray-500 space-x-4" data-id="element-129">
          <a href="#" className="hover:text-white transition-colors" data-id="element-130">
            Privacy Policy
          </a>
          <span data-id="element-131">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-132">
            Terms and Conditions
          </a>
        </div>
      </div>
    </footer>;
}